import React, { useEffect, useState } from 'react';
import { Subject } from 'rxjs';

import { Loader } from '../../element/Loader/Loader';
import type { LoaderExtendedProps } from '../../element/LoaderWithVerbiage/LoaderWithVerbiage';
import { LoaderWithVerbiage } from '../../element/LoaderWithVerbiage/LoaderWithVerbiage';

const BlockerEvent = new Subject();
const blockerEvents = new Set();
export const BlockerUtil = {
  block(loaderExtended?: LoaderExtendedProps) {
    const eventTimestamp = new Date().toISOString();
    if (loaderExtended) {
      blockerEvents.add(eventTimestamp);
      BlockerEvent.next(loaderExtended);
    } else {
      blockerEvents.add(eventTimestamp);
      BlockerEvent.next(eventTimestamp);
    }
    return eventTimestamp;
  },
  unblock(eventTimestamp: string) {
    blockerEvents.delete(eventTimestamp);
    BlockerEvent.next(eventTimestamp);
  },
  unblockAll() {
    blockerEvents.clear();
    BlockerEvent.next('');
  },
  clearForTesting() {
    blockerEvents.clear();
  },
};

export const Blocker = ({ children }: { children: React.ReactNode }) => {
  const [showBlocker, setShowBlocker] = useState(false);
  const [loaderExtendedProps, setLoaderExtendedProps] =
    useState<LoaderExtendedProps | null>(null);

  useEffect(() => {
    const subscription = BlockerEvent.subscribe({
      next: value => {
        setShowBlocker(blockerEvents.size > 0);
        if (
          value &&
          typeof value === 'object' &&
          ('headers' in value || 'description' in value)
        ) {
          setLoaderExtendedProps(value as LoaderExtendedProps);
        } else if (blockerEvents.size === 0) {
          setLoaderExtendedProps(null);
        }
      },
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <>
      {!!showBlocker &&
        (loaderExtendedProps ? (
          <LoaderWithVerbiage
            name="blocking-loader"
            loaderExtended={loaderExtendedProps}
          />
        ) : (
          <Loader expand="fullscreen" name="blocking-loader" />
        ))}
      <div data-test="BLOCKER_CONTENT">{children}</div>
    </>
  );
};
